export default "__VITE_ASSET__f5f38e1e__"